/** Shared Arabic labels for statuses, services, and related enums. */

export const STATUS_LABELS: Record<string, string> = {
  active: 'فعال',
  blocked: 'محظور',
  pending: 'قيد الانتظار',
  approved: 'مقبول',
  rejected: 'مرفوض',
  not_submitted: 'غير مقدَّم',
  deleted: 'محذوف',
  success: 'ناجح',
  failed: 'فاشل',
  processing: 'قيد التنفيذ',
  refunded: 'مسترجع',
  pending_review: 'بانتظار التحقق',
  submitting: 'جاري التقديم',
  submitted: 'تم التقديم',
  cancelled: 'ملغى',
  open: 'مفتوح',
  closed: 'مغلق',
  hidden: 'مخفية',
  inactive: 'غير مفعل',
  wait: 'بانتظار الرد',
  accept: 'مقبول',
  reject: 'مرفوض',
  queued: 'في الطابور',
  assigned: 'مستلم',
  executing: 'قيد التنفيذ',
  review: 'بانتظار التحقق',
  completed: 'مكتمل',
};

export const SERVICE_LABELS: Record<string, string> = {
  customer_recharge: 'شحن وحدات',
  distributor_recharge: 'شحن موزع',
  syriatel_mobile_recharge: 'شحن سيريتل',
  syriatel_cash_transfer: 'تحويل كاش سيريتل',
  product_order: 'طلب منتج',
  games_order: 'طلب ألعاب',
  bill_order: 'دفع فاتورة',
  deposit_request: 'شحن محفظة',
};

export const COMPANY_LABELS: Record<string, string> = {
  syriatel: 'سيريتل',
  mtn: 'MTN',
};

export const KIND_LABELS: Record<string, string> = {
  units: 'وحدات',
  bills: 'فاتورة',
  cash: 'كاش',
};

export const SOURCE_LABELS: Record<string, string> = {
  sham_balance: 'Sham Balance',
  kazeti_ussd: 'USSD',
  api_syria: 'API Syria',
  manual: 'يدوي',
};

export const PROVIDER_TYPE_OPTIONS: Array<{ value: string; label: string; baseUrl: string }> = [
  { value: 'generic', label: 'مصدر Eshhanle API', baseUrl: 'https://api.eshhanle.com' },
  { value: 'kokos', label: 'Kokos Activator', baseUrl: 'https://api.kokos.cc' },
  { value: 's4_robot', label: 'S4 Robot', baseUrl: 'https://api.s4-robot.com/v1' },
  { value: 'sw_games', label: 'sw-games', baseUrl: 'https://sw-games.net/api/fastapi' },
];

export function labelOf(map: Record<string, string>, value: unknown, fallback = '—'): string {
  const key = String(value ?? '')
    .trim()
    .toLowerCase();
  if (!key) return fallback;
  return map[key] ?? String(value ?? fallback);
}

export function statusLabel(status: unknown): string {
  return labelOf(STATUS_LABELS, status, String(status ?? '—'));
}

export function serviceLabel(service: unknown): string {
  return labelOf(SERVICE_LABELS, service, String(service ?? '—'));
}

export function orderTitle(order: {
  label?: unknown;
  product_name?: unknown;
  service?: unknown;
  id?: unknown;
}): string {
  const label = String(order.label ?? '').trim();
  if (label && !SERVICE_LABELS[label.toLowerCase()]) return label;
  const product = String(order.product_name ?? '').trim();
  if (product) return product;
  const svc = String(order.service ?? '').trim();
  if (svc) return serviceLabel(svc);
  return `طلب #${String(order.id ?? '')}`;
}

export function isOpenOrderStatus(status: unknown): boolean {
  const s = String(status ?? '').toLowerCase();
  // Do not treat rejected/failed/pending as open — terminal outcomes must stop polling.
  return ['processing', 'submitting', 'submitted', 'wait', 'queued', 'assigned', 'executing', 'review'].includes(s);
}
